export const DEFAULT_COUNTRY = ["IN", "India"];

export const DEFAULT_ADDRESS_FORMAT = {
  fields: {
    city: {
      label: "City",
      is_hidden: false,
    },
    city_area: {
      label: "Suburb",
      is_hidden: true,
    },
    country_area: {
      label: "State",
      is_hidden: false,
      choices: [
        ["Andaman and Nicobar Islands", "Andaman & Nicobar"],
        ["Andhra Pradesh", "Andhra Pradesh"],
        ["Arunachal Pradesh", "Arunachal Pradesh"],
        ["Assam", "Assam"],
        ["Bihar", "Bihar"],
        ["Chandigarh", "Chandigarh"],
        ["Chhattisgarh", "Chhattisgarh"],
        ["Dadra and Nagar Haveli", "Dadra & Nagar Haveli"],
        ["Daman and Diu", "Daman & Diu"],
        ["Delhi", "Delhi"],
        ["Goa", "Goa"],
        ["Gujarat", "Gujarat"],
        ["Haryana", "Haryana"],
        ["Himachal Pradesh", "Himachal Pradesh"],
        ["Jammu and Kashmir", "Jammu & Kashmir"],
        ["Jharkhand", "Jharkhand"],
        ["Karnataka", "Karnataka"],
        ["Kerala", "Kerala"],
        ["Lakshadweep", "Lakshadweep"],
        ["Madhya Pradesh", "Madhya Pradesh"],
        ["Maharashtra", "Maharashtra"],
        ["Manipur", "Manipur"],
        ["Meghalaya", "Meghalaya"],
        ["Mizoram", "Mizoram"],
        ["Nagaland", "Nagaland"],
        ["Odisha", "Odisha"],
        ["Puducherry", "Puducherry"],
        ["Punjab", "Punjab"],
        ["Rajasthan", "Rajasthan"],
        ["Sikkim", "Sikkim"],
        ["Tamil Nadu", "Tamil Nadu"],
        ["Telangana", "Telangana"],
        ["Tripura", "Tripura"],
        ["Uttar Pradesh", "Uttar Pradesh"],
        ["Uttarakhand", "Uttarakhand"],
        ["West Bengal", "West Bengal"],
      ],
    },
  },
  country: "IN",
};

export const DEFAULT_COUNTRY_CODE = "+91";